jQuery(function($) {
     $('#bookingPopup-form').validate({
        rules: {
            name: {
                required: true,
                minlength: 2
            },
            email: {
                required: true,
                email: true
            },
            message: {
                required: true,
            }
        },
        messages: {
            name: {
                required: "Please enter your name",
                minlength: "Your name must consist of at least 2 characters"
            },
            email: {
                required: "Please enter your email"
            },
            message: {
                required: "Please enter your message"
            }
        },
       submitHandler: function(form) {
          
        }
    });
    function closeModal(){
        $('.popup-wrap').each(function(index){
            if($(this).hasClass('show')){
                $(this).find('.form-popup .close').trigger('click');
            }
        });
    };
    $('#contactform').validate({
        rules: {
            name: {
                required: true,
                minlength: 2
            },
            email: {
                required: true,
                email: true
            },
            message: {
                required: true,
            }
        },
        messages: {
            name: {
                required: "Please enter your name",
                minlength: "Your name must consist of at least 2 characters"
            },
            email: {
                required: "Please enter your email"
            },
            message: {
                required: "Please enter your message"
            }
        },
        submitHandler: function(form) {
           
        }
    });
    $('#newsletterform').validate({
        rules: {
            email: {
                required: true,
                email: true
            }
        },
        submitHandler: function(form) {
           
        }
    });
});